module.exports = __webpack_public_path__ + "static/img/3.09f92355.png";